<div
  class="circle-text-avatar"
  [ngStyle]="{ 'background-color': backGroundColor }"
>
  {{ firstName && firstName.length > 0 ? firstName.charAt(0).toUpperCase() : ''
  }}{{
    lastName && lastName.length >= 0 ? lastName.charAt(0).toUpperCase() : ''
  }}
</div>
